import './commonAssets';

import '../common/stylesheets/modules/collections/collection-browse.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../graphicstock/components/markup-mixins.less';
import '../graphicstock/modules/search/search-results-page.less';
import '../graphicstock/modules/search/searchResults.less';
import '../storyblocks/stylesheets/modules/home/storyblocks-home-redesign.less';


import AppLoader from '../react/AppLoader/AppLoader';

import SearchResultsContainer from '../react/app/Search/containers/SearchResultsContainer';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import ImageSearchContainer from '../react/app/Search/containers/ImageSearchContainer';
import ImageSiteConstants from '../react/common/SiteConstants/ImageSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      path: new ImageSiteConstants().getSearchRoute() + '*',
      component: ImageSearchContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'search-results-container': SearchResultsContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
